/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id   : 'reports',
        title: 'Reports',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/reports'
    },
    {
        id   : 'settings',
        title: 'Settings',
        type : 'basic',
        icon : 'heroicons_outline:cog-6-tooth',
        link : '/settings'
    },
    {
        id   : 'feedback',
        title: 'Feedback',
        type : 'basic',
        icon : 'heroicons_outline:chat-bubble-oval-left',
        link : '/feedback'
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'reports',
        title: 'Reports',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/reports'
    },
    {
        id   : 'settings',
        title: 'Settings',
        type : 'basic',
        icon : 'heroicons_outline:cog-6-tooth',
        link : '/settings'
    },
    {
        id   : 'feedback',
        title: 'Feedback',
        type : 'basic',
        icon : 'heroicons_outline:chat-bubble-oval-left',
        link : '/feedback'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'reports',
        title: 'Reports',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/reports'
    },
    {
        id   : 'settings',
        title: 'Settings',
        type : 'basic',
        icon : 'heroicons_outline:cog-6-tooth',
        link : '/settings'
    },
    {
        id   : 'feedback',
        title: 'Feedback',
        type : 'basic',
        icon : 'heroicons_outline:chat-bubble-oval-left',
        link : '/feedback'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'reports',
        title: 'Reports',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/reports'
    },
    {
        id   : 'settings',
        title: 'Settings',
        type : 'basic',
        icon : 'heroicons_outline:cog-6-tooth',
        link : '/settings'
    },
    {
        id   : 'feedback',
        title: 'Feedback',
        type : 'basic',
        icon : 'heroicons_outline:chat-bubble-oval-left',
        link : '/feedback'
    }
];
